// extracted by mini-css-extract-plugin
export default {"sliderOptions":"UWbgobqQ686Q5vLWEdij"};